
































































































































































import { Component } from "vue-property-decorator";
import { mapState } from "vuex";
import Vue from "vue";

@Component({
  computed: {
    ...mapState([])
  }
})
export default class Footer extends Vue {
  // Mapped from Vuex
}
